exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Open+Sans:300,300i,400,400i,600,700);", ""]);
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Oswald:300,400,600,700);", ""]);

// module
exports.push([module.id, "body{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased}.no-select{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.quick-complete-slideout-container{position:absolute;left:0;top:4px;width:100%;height:54px;background-color:transparent}.quick-complete-slideout-container .quick-complete-slideout{background-color:transparent;position:absolute;height:54px;display:flex;padding-left:16px;cursor:pointer}.quick-complete-slideout-container .quick-complete-slideout .slideout-handle{width:8px;height:54px;background-color:#184e78;border-top-left-radius:3px;border-bottom-left-radius:3px}.quick-complete-slideout-container .quick-complete-slideout .action-container{width:54px;height:54px}", ""]);

// exports
exports.locals = {
	"addGreen": "#4bb543",
	"inProgress": "#f5a623",
	"complete": "#5db348",
	"iconGrey": "#A4A4A4",
	"warmGreyTwo": "#9b9b9b",
	"gray": "#676767",
	"offBlack": "#2C2C2C",
	"lightElement": "#D8D8D8",
	"white": "#fff",
	"aoDarkBlue": "#184e78",
	"secondaryLabelFont": "#bababa",
	"nonExistant": "#9b9b9b",
	"red": "#D0011B"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/components/QuickCompleteSlideout/QuickCompleteSlideout.scss
// module id = 1612
// module chunks = 0